<template>
  <div class="admin-dashboard-root min-h-screen bg-slate-50 flex">
<main class="flex-1 p-6 lg:p-8">
      <div class="dashboard-container">
      <header class="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
        <div>
          <h1 class="text-2xl font-bold text-slate-800">Panel de Control Admin</h1>
          <p class="text-slate-500">Estado global de la infraestructura multiempresa.</p>
        </div>
        <div class="flex items-center gap-3">
          <select class="bg-white border border-slate-200 rounded-lg px-4 py-2 text-sm shadow-sm outline-none">
            <option>Últimos 30 días</option>
            <option>Últimos 7 días</option>
            <option>Este año</option>
          </select>
          <button class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition shadow-md shadow-blue-200">
            Nueva Empresa +
          </button>
        </div>
      </header>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <p class="text-sm text-slate-500 font-medium">Empresas Activas</p>
          <div class="flex items-end justify-between mt-2">
            <h2 class="text-3xl font-bold text-slate-800">124</h2>
            <span class="text-green-500 text-xs font-bold bg-green-50 px-2 py-1 rounded">+12%</span>
          </div>
        </div>
        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <p class="text-sm text-slate-500 font-medium">Ingresos Mensuales (MRR)</p>
          <div class="flex items-end justify-between mt-2">
            <h2 class="text-3xl font-bold text-slate-800">$12,450</h2>
            <span class="text-blue-500 text-xs font-bold bg-blue-50 px-2 py-1 rounded">Estable</span>
          </div>
        </div>
        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <p class="text-sm text-slate-500 font-medium">Uso de Módulos (Promedio)</p>
          <div class="flex items-end justify-between mt-2">
            <h2 class="text-3xl font-bold text-slate-800">84%</h2>
            <span class="text-green-500 text-xs font-bold bg-green-50 px-2 py-1 rounded">↑ Alta</span>
          </div>
        </div>
        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <p class="text-sm text-slate-500 font-medium">Tasa de Churn (Bajas)</p>
          <div class="flex items-end justify-between mt-2">
            <h2 class="text-3xl font-bold text-slate-800">1.2%</h2>
            <span class="text-red-500 text-xs font-bold bg-red-50 px-2 py-1 rounded">↓ -0.5%</span>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
        <div class="lg:col-span-2 bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <div class="flex items-center justify-between mb-6">
            <h3 class="font-bold text-slate-800">Crecimiento de Tenants</h3>
            <span class="text-xs text-slate-400">Enero - Diciembre 2026</span>
          </div>
          <div class="h-64 bg-slate-50 rounded-lg flex items-end justify-around p-4 gap-2">
            <div class="w-full bg-blue-200 rounded-t h-[30%]"></div>
            <div class="w-full bg-blue-300 rounded-t h-[45%]"></div>
            <div class="w-full bg-blue-400 rounded-t h-[60%]"></div>
            <div class="w-full bg-blue-500 rounded-t h-[85%]"></div>
            <div class="w-full bg-blue-600 rounded-t h-[100%]"></div>
          </div>
        </div>

        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <h3 class="font-bold text-slate-800 mb-6">Planes Activos</h3>
          <div class="space-y-4">
            <div v-for="plan in plans" :key="plan.name">
              <div class="flex justify-between text-sm mb-1">
                <span class="text-slate-600 font-medium">{{ plan.name }}</span>
                <span class="text-slate-400">{{ plan.count }} empresas</span>
              </div>
              <div class="w-full bg-slate-100 rounded-full h-2">
                <div :class="['h-2 rounded-full', plan.color]" :style="{ width: plan.percent + '%' }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
          <div class="p-4 border-b border-slate-100 bg-slate-50/50">
            <h3 class="font-bold text-slate-800 text-sm">Últimas Empresas Registradas</h3>
          </div>
          <table class="w-full text-left text-sm">
            <tbody class="divide-y divide-slate-100">
              <tr v-for="i in 4" :key="i" class="hover:bg-slate-50 transition">
                <td class="p-4 flex items-center gap-3">
                  <div class="w-8 h-8 rounded bg-slate-200"></div>
                  <span class="font-medium text-slate-700">Empresa Alpha {{ i }}</span>
                </td>
                <td class="p-4 text-slate-500 text-xs font-mono">alpha{{ i }}.saas.io</td>
                <td class="p-4 text-right">
                  <span class="px-2 py-0.5 rounded-full text-[10px] font-bold bg-blue-100 text-blue-700">PLAN PRO</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
          <h3 class="font-bold text-slate-800 mb-4 text-sm">Estado Global de Módulos</h3>
          <div class="grid grid-cols-2 gap-4">
            <div v-for="module in modules" :key="module.name" class="p-3 border border-slate-100 rounded-lg flex items-center justify-between">
              <div>
                <p class="text-xs font-bold text-slate-700">{{ module.name }}</p>
                <p class="text-[10px] text-slate-400">{{ module.activeTenants }} tenants</p>
              </div>
              <div :class="['w-2 h-2 rounded-full', module.status === 'ok' ? 'bg-green-500' : 'bg-red-500 animate-pulse']"></div>
            </div>
          </div>
        </div>
      </div>
          </div>
    </main>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const plans = ref([
  { name: 'Enterprise', count: 12, percent: 30, color: 'bg-indigo-600' },
  { name: 'Business Pro', count: 45, percent: 60, color: 'bg-blue-500' },
  { name: 'Starter', count: 67, percent: 85, color: 'bg-emerald-400' }
])

const modules = ref([
  { name: 'Facturación Electrónica', activeTenants: 120, status: 'ok' },
  { name: 'Gestión de Inventarios', activeTenants: 98, status: 'ok' },
  { name: 'API Externa', activeTenants: 45, status: 'error' },
  { name: 'Reportes BI', activeTenants: 110, status: 'ok' }
])
</script>

<style scoped>
* { box-sizing: border-box; }

.min-h-screen { min-height: 100vh; }
.flex { display: flex; }
.flex-col { flex-direction: column; }
.flex-1 { flex: 1 1 0%; }
.hidden { display: none; }

.grid { display: grid; }
.grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }
.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }

.w-64 { width: 16rem; }
.w-8 { width: 2rem; }
.w-2 { width: 0.5rem; }
.w-full { width: 100%; }
.h-8 { height: 2rem; }
.h-2 { height: 0.5rem; }
.h-64 { height: 16rem; }

.h-\[30\%\] { height: 30%; }
.h-\[45\%\] { height: 45%; }
.h-\[60\%\] { height: 60%; }
.h-\[85\%\] { height: 85%; }
.h-\[100\%\] { height: 100%; }

.p-3 { padding: 0.75rem; }
.p-4 { padding: 1rem; }
.p-6 { padding: 1.5rem; }
.p-8 { padding: 2rem; }
.px-2 { padding-left: 0.5rem; padding-right: 0.5rem; }
.px-3 { padding-left: 0.75rem; padding-right: 0.75rem; }
.px-4 { padding-left: 1rem; padding-right: 1rem; }
.py-0\.5 { padding-top: 0.125rem; padding-bottom: 0.125rem; }
.py-1 { padding-top: 0.25rem; padding-bottom: 0.25rem; }
.py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; }
.py-4 { padding-top: 1rem; padding-bottom: 1rem; }

.mb-1 { margin-bottom: 0.25rem; }
.mb-4 { margin-bottom: 1rem; }
.mb-6 { margin-bottom: 1.5rem; }
.mb-8 { margin-bottom: 2rem; }
.mt-2 { margin-top: 0.5rem; }
.gap-2 { gap: 0.5rem; }
.gap-3 { gap: 0.75rem; }
.gap-4 { gap: 1rem; }
.gap-6 { gap: 1.5rem; }

.space-y-1 > * + * { margin-top: 0.25rem; }
.space-y-4 > * + * { margin-top: 1rem; }

.items-center { align-items: center; }
.items-end { align-items: flex-end; }
.justify-between { justify-content: space-between; }
.justify-around { justify-content: space-around; }

.overflow-hidden { overflow: hidden; }
.text-left { text-align: left; }
.text-right { text-align: right; }
.uppercase { text-transform: uppercase; }

.text-\[10px\] { font-size: 10px; line-height: 1.2; }
.text-xs { font-size: 0.75rem; line-height: 1rem; }
.text-sm { font-size: 0.875rem; line-height: 1.25rem; }
.text-xl { font-size: 1.25rem; line-height: 1.75rem; }
.text-2xl { font-size: 1.5rem; line-height: 2rem; }
.text-3xl { font-size: 1.875rem; line-height: 2.25rem; }

.font-medium { font-weight: 500; }
.font-semibold { font-weight: 600; }
.font-bold { font-weight: 700; }
.font-mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; }

.rounded { border-radius: 0.25rem; }
.rounded-lg { border-radius: 0.5rem; }
.rounded-xl { border-radius: 0.75rem; }
.rounded-full { border-radius: 9999px; }
.rounded-t { border-top-left-radius: 0.5rem; border-top-right-radius: 0.5rem; }

.border { border: 1px solid #e2e8f0; }
.border-b { border-bottom: 1px solid #e2e8f0; }
.border-slate-100 { border-color: #f1f5f9; }
.border-slate-200 { border-color: #e2e8f0; }

.bg-white { background: #ffffff; }
.bg-slate-900 { background: #0f172a; }
.bg-slate-800 { background: #1e293b; }
.bg-slate-100 { background: #f1f5f9; }
.bg-slate-50 { background: #f8fafc; }
.bg-slate-50\/50 { background: rgba(248, 250, 252, 0.5); }

.bg-blue-50 { background: #eff6ff; }
.bg-blue-100 { background: #dbeafe; }
.bg-blue-200 { background: #bfdbfe; }
.bg-blue-300 { background: #93c5fd; }
.bg-blue-400 { background: #60a5fa; }
.bg-blue-500 { background: #3b82f6; }
.bg-blue-600 { background: #2563eb; }
.bg-indigo-600 { background: #4f46e5; }
.bg-emerald-400 { background: #34d399; }
.bg-green-50 { background: #f0fdf4; }
.bg-green-500 { background: #22c55e; }
.bg-red-50 { background: #fef2f2; }
.bg-red-500 { background: #ef4444; }

.text-white { color: #ffffff; }
.text-slate-300 { color: #cbd5e1; }
.text-slate-400 { color: #94a3b8; }
.text-slate-500 { color: #64748b; }
.text-slate-600 { color: #475569; }
.text-slate-700 { color: #334155; }
.text-slate-800 { color: #1e293b; }
.text-blue-400 { color: #60a5fa; }
.text-blue-500 { color: #3b82f6; }
.text-blue-700 { color: #1d4ed8; }
.text-green-500 { color: #22c55e; }
.text-red-500 { color: #ef4444; }

.shadow-sm { box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06); }
.shadow-md { box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12); }
.shadow-blue-200 { box-shadow: 0 8px 20px rgba(147, 197, 253, 0.45); }

.transition { transition: all 0.2s ease; }
.hover\:bg-slate-800:hover { background: #1e293b; }
.hover\:bg-blue-700:hover { background: #1d4ed8; }
.hover\:bg-slate-50:hover { background: #f8fafc; }

.outline-none { outline: none; }

.divide-y > * + * { border-top: 1px solid #f1f5f9; }

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
}

.animate-pulse { animation: pulse 1.6s ease-in-out infinite; }
.dashboard-container { max-width: 1480px; margin: 0 auto; }

@media (min-width: 768px) {
  .md\:flex-row { flex-direction: row; }
  .md\:items-center { align-items: center; }
  .md\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (min-width: 1024px) {
  .lg\:flex { display: flex; }
  .lg\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .lg\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .lg\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .lg\:col-span-2 { grid-column: span 2 / span 2; }
}

/* Integracion con tema claro/oscuro del sistema */
.bg-slate-50 { background: var(--bg-main); }
.bg-slate-50\/50 { background: var(--secondary-bg-main); }
.bg-white { background: var(--secondary-bg-main); }
.bg-slate-100 { background: var(--secondary-bg-soft); }

.border,
.border-b,
.border-slate-100,
.border-slate-200 {
  border-color: var(--border-main);
}

.text-slate-300,
.text-slate-400 { color: var(--text-muted); }

.text-slate-500,
.text-slate-600,
.text-slate-700 { color: var(--text-secondary); }

.text-slate-800 { color: var(--text-primary); }

select,
input {
  background: var(--secondary-bg-main);
  color: var(--text-primary);
  border-color: var(--border-main);
}

.shadow-sm,
.shadow-md { box-shadow: var(--shadow-sm); }

/* Ajuste completo de utilidades al tema del sistema */
.min-h-screen { background: var(--bg-main) !important; color: var(--text-primary); }

.bg-slate-900 { background: var(--secondary-bg-soft); }
.bg-slate-800 { background: var(--secondary-bg-muted); }

.text-white { color: var(--text-inverse); }
.text-slate-300,
.text-slate-400,
.text-slate-500,
.text-slate-600,
.text-slate-700,
.text-slate-800 { color: var(--text-primary) !important; }

.text-slate-400,
.text-slate-500,
.text-slate-600 { color: var(--text-secondary) !important; }

.divide-y > * + * { border-top-color: var(--border-main) !important; }

.hover\:bg-slate-50:hover { background: var(--secondary-bg-soft) !important; }

.bg-blue-50 { background: var(--accent-info-light); }
.bg-green-50 { background: var(--accent-success-light); }
.bg-red-50 { background: var(--accent-danger-light); }

.bg-blue-100 { background: rgba(14, 165, 233, 0.2); }
.bg-blue-200 { background: rgba(14, 165, 233, 0.35); }
.bg-blue-300 { background: rgba(14, 165, 233, 0.5); }
.bg-blue-400 { background: rgba(14, 165, 233, 0.65); }
.bg-blue-500 { background: var(--primary-main); }
.bg-blue-600 { background: var(--primary-main); }
.bg-indigo-600 { background: var(--primary-hover); }
.bg-emerald-400 { background: var(--accent-success); }
.bg-red-500 { background: var(--accent-danger); }
.bg-green-500 { background: var(--accent-success); }

.text-blue-500,
.text-blue-700 { color: var(--accent-info); }
.text-green-500 { color: var(--accent-success); }
.text-red-500 { color: var(--accent-danger); }

.hover\:bg-blue-700:hover { background: var(--primary-hover) !important; }

/* Forzar tema por contenedor real del dashboard (fallback incluido) */
.admin-dashboard-root {
  --fondo-principal-local: var(--bg-main, #f8fafc);
  --fondo-secundario-local: var(--secondary-bg-main, #ffffff);
  --fondo-suave-local: var(--secondary-bg-soft, #f1f5f9);
  --texto-principal-local: var(--text-primary, #0f172a);
  --texto-secundario-local: var(--text-secondary, #475569);
  --borde-local: var(--border-main, #e2e8f0);
  background: var(--fondo-principal-local) !important;
  color: var(--texto-principal-local) !important;
}

@media (prefers-color-scheme: dark) {
  .admin-dashboard-root {
    --fondo-principal-local: var(--bg-main, #020617);
    --fondo-secundario-local: var(--secondary-bg-main, #111827);
    --fondo-suave-local: var(--secondary-bg-soft, #0f172a);
    --texto-principal-local: var(--text-primary, #f9fafb);
    --texto-secundario-local: var(--text-secondary, #94a3b8);
    --borde-local: var(--border-main, #374151);
  }
}

.admin-dashboard-root .bg-white {
  background: var(--fondo-secundario-local) !important;
  border-color: var(--borde-local) !important;
}

.admin-dashboard-root .bg-slate-50,
.admin-dashboard-root .bg-slate-50\/50,
.admin-dashboard-root .bg-slate-100 {
  background: var(--fondo-suave-local) !important;
}

.admin-dashboard-root .border,
.admin-dashboard-root .border-b,
.admin-dashboard-root .border-slate-100,
.admin-dashboard-root .border-slate-200 {
  border-color: var(--borde-local) !important;
}

.admin-dashboard-root .text-slate-800,
.admin-dashboard-root .text-slate-700,
.admin-dashboard-root .text-slate-600,
.admin-dashboard-root .text-slate-500,
.admin-dashboard-root .text-slate-400 {
  color: var(--texto-secundario-local) !important;
}

.admin-dashboard-root .text-slate-800,
.admin-dashboard-root .font-bold.text-slate-700,
.admin-dashboard-root h1,
.admin-dashboard-root h2,
.admin-dashboard-root h3 {
  color: var(--texto-principal-local) !important;
}
</style>


